import { property as e } from "lit/decorators.js";
import { SpectrumElement as l } from "@spectrum-web-components/core/shared/base/index.js";
import { ASSET_VARIANTS as y } from "./Asset.types.js";
var u = Object.defineProperty, o = (s, i, p, n) => {
  for (var r = void 0, a = s.length - 1, c; a >= 0; a--)
    (c = s[a]) && (r = c(i, p, r) || r);
  return r && u(i, p, r), r;
};
class t extends l {
  constructor() {
    super(...arguments), this.label = "", this.error = !1;
  }
  // ──────────────────────
  //     IMPLEMENTATION
  // ──────────────────────
  updated(i) {
    var p;
    if (super.updated(i), (p = window.__swc) != null && p.DEBUG) {
      const n = this.constructor;
      typeof this.variant != "undefined" && !n.VARIANTS.includes(this.variant) && window.__swc.warn(
        this,
        `<${this.localName}> element expects the "variant" attribute to be one of the following:`,
        "https://opensource.adobe.com/spectrum-web-components/components/asset/",
        {
          issues: [...n.VARIANTS]
        }
      ), this.src && !this.alt && window.__swc.warn(
        this,
        `<${this.localName}> element with "src" should include an "alt" attribute for accessibility.`,
        "https://opensource.adobe.com/spectrum-web-components/components/asset/",
        {
          issues: ["Missing alt text"]
        }
      );
    }
  }
}
t.VARIANTS = y;
o([
  e({ type: String, reflect: !0 })
], t.prototype, "variant");
o([
  e()
], t.prototype, "label");
o([
  e({ type: Boolean, reflect: !0 })
], t.prototype, "error");
o([
  e({ type: String })
], t.prototype, "src");
o([
  e({ type: String })
], t.prototype, "alt");
o([
  e({ type: String })
], t.prototype, "loading");
o([
  e({ type: String, attribute: "object-fit" })
], t.prototype, "objectFit");
o([
  e({ type: String, attribute: "object-position" })
], t.prototype, "objectPosition");
o([
  e({ type: String })
], t.prototype, "srcset");
o([
  e({ type: String })
], t.prototype, "sizes");
o([
  e({ type: String })
], t.prototype, "decoding");
o([
  e({ type: String })
], t.prototype, "crossorigin");
o([
  e({ type: String })
], t.prototype, "referrerpolicy");
o([
  e({ type: Number })
], t.prototype, "width");
o([
  e({ type: Number })
], t.prototype, "height");
export {
  t as AssetBase
};
//# sourceMappingURL=Asset.base.js.map
